const dataSearchUserManager = {
  stateData: [
    { value: 2, label: "Tất cả" },
    { value: 1, label: "Hoạt Động" },
    { value: 0, label: "Khóa" },
  ],
  roleData: [
    { value: "ALL", label: "Tất cả" },
    { value: "BAN DU AN", label: "Ban Dự Án" },
    { value: "NHAN VIEN", label: "Nhân Viên" },
  ],
};
export default dataSearchUserManager;
